// Module
var code = "<div layout=\"column\" class=\"md-padding\" layout-fill> <p class=\"md-subhead text-center\"> Please contact the owner of this building to continue </p> </div> ";
// Exports
module.exports = code;